"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var react_quill_1 = __importDefault(require("react-quill"));
require("react-quill/dist/quill.snow.css");
var styles_1 = require("../../styles");
require("./AudioBlot");
require("./DividerBlot");
require("./VideoBlot");
var utils_1 = require("../../utils");
var icons_1 = require("@ant-design/icons");
var config_1 = require("../../config");
var hooks_1 = require("../../hooks");
var hooks_2 = require("../../modules/stations/hooks");
var styles = {
    modalFormSpace: { width: "100%" },
    modalFormSelect: { width: "100%" },
    imageOptionText: { marginLeft: 8, verticalAlign: "top" },
    editorContainer: { position: "relative" },
    extraToolbar: { position: "absolute", top: 5, right: 16 },
    extraToolbarDivider: { margin: "0 6px" },
};
var FORMATS = [
    "header",
    "bold",
    "italic",
    "underline",
    "list",
    "bullet",
    "link",
    "image",
    "video",
    "tgcsAudio",
    "html5Video",
    "divider",
];
var filterOption = function (v, option) { var _a; return ((_a = option.search) !== null && _a !== void 0 ? _a : option.value).toLocaleLowerCase().includes(v.toLocaleLowerCase()); };
var LinkModal = react_1.default.memo(function (_a) {
    var options = _a.options, objectName = _a.objectName, objectPathItem = _a.objectPathItem, linkText = _a.linkText, onOk = _a.onOk, onCancel = _a.onCancel, open = _a.open;
    var _b = (0, react_1.useState)(null), selectedItem = _b[0], setSelectedItem = _b[1];
    var onOk_ = (0, react_1.useCallback)(function () {
        if (!selectedItem)
            return;
        onOk("".concat(config_1.APP_BASE_URL, "/").concat(objectPathItem, "/").concat(selectedItem));
        setSelectedItem(null);
    }, [objectPathItem, selectedItem, onOk]);
    var mappedOptions = (0, react_1.useMemo)(function () { return options.map(function (item) { return ({
        label: item.title,
        value: item.id,
        search: item.title,
    }); }); }, [options]);
    // noinspection JSValidateTypes
    return react_1.default.createElement(antd_1.Modal, { title: "Insert ".concat(objectName, " Link"), onOk: onOk_, onCancel: onCancel, open: open },
        react_1.default.createElement(antd_1.Space, { direction: "vertical", style: styles.modalFormSpace },
            react_1.default.createElement("div", null,
                react_1.default.createElement("strong", null, "Link text:"),
                " ",
                linkText),
            react_1.default.createElement("div", null,
                react_1.default.createElement(antd_1.Select, { placeholder: objectName, showSearch: true, filterOption: filterOption, onChange: function (itemId) { return setSelectedItem(itemId); }, value: selectedItem, style: styles.modalFormSelect, size: "large", options: mappedOptions }))));
});
var AssetModalProps = /** @class */ (function () {
    function AssetModalProps() {
    }
    return AssetModalProps;
}());
var AudioModal = react_1.default.memo(function (_a) {
    var assetOptions = _a.assetOptions, onOk = _a.onOk, onCancel = _a.onCancel, open = _a.open;
    var _b = (0, react_1.useState)(false), displayAsLink = _b[0], setDisplayAsLink = _b[1];
    var _c = (0, react_1.useState)(""), linkText = _c[0], setLinkText = _c[1];
    var _d = (0, react_1.useState)(null), selectedAsset = _d[0], setSelectedAsset = _d[1];
    var onOk_ = (0, react_1.useCallback)(function () {
        if (!selectedAsset)
            return;
        onOk({
            url: (0, utils_1.assetIdToBytesUrl)(selectedAsset),
            linkText: linkText || undefined,
        });
        setSelectedAsset(null);
    }, [selectedAsset, onOk]);
    var options = (0, react_1.useMemo)(function () { return assetOptions.map(function (asset) { return ({
        label: asset.file_name,
        value: asset.id,
        search: asset.file_name,
    }); }); }, [assetOptions]);
    // noinspection JSValidateTypes
    return react_1.default.createElement(antd_1.Modal, { title: "Insert Audio", onOk: onOk_, onCancel: onCancel, open: open },
        react_1.default.createElement(antd_1.Space, { direction: "vertical", style: styles.modalFormSpace },
            react_1.default.createElement("div", null,
                react_1.default.createElement(antd_1.Checkbox, { checked: displayAsLink, onChange: function (e) { return setDisplayAsLink(e.target.checked); } }, "Display as link")),
            react_1.default.createElement("div", null,
                react_1.default.createElement(antd_1.Input, { placeholder: "Link text", disabled: !displayAsLink, value: displayAsLink ? linkText : "", onChange: function (e) { return setLinkText(e.target.value); } })),
            react_1.default.createElement("div", null,
                react_1.default.createElement(antd_1.Select, { placeholder: "Audio asset", showSearch: true, filterOption: filterOption, onChange: function (asset) { return setSelectedAsset(asset); }, value: selectedAsset, style: styles.modalFormSelect, size: "large", options: options }))));
});
var ImageModal = react_1.default.memo(function (_a) {
    var assetOptions = _a.assetOptions, onOk = _a.onOk, onCancel = _a.onCancel, open = _a.open;
    var _b = (0, react_1.useState)(null), selectedAsset = _b[0], setSelectedAsset = _b[1];
    var onOk_ = (0, react_1.useCallback)(function () {
        if (!selectedAsset)
            return;
        onOk((0, utils_1.assetIdToBytesUrl)(selectedAsset));
        setSelectedAsset(null);
    }, [selectedAsset, onOk]);
    var options = (0, react_1.useMemo)(function () { return assetOptions.map(function (asset) { return ({
        label: react_1.default.createElement("div", null,
            react_1.default.createElement(antd_1.Image, { src: (0, utils_1.assetIdToBytesUrl)(asset.id), height: 40 }),
            react_1.default.createElement("span", { style: styles.imageOptionText }, asset.file_name)),
        value: asset.id,
        search: asset.file_name,
    }); }); }, [assetOptions]);
    // noinspection JSValidateTypes
    return react_1.default.createElement(antd_1.Modal, { title: "Insert Image", open: open, onOk: onOk_, onCancel: onCancel },
        react_1.default.createElement(antd_1.Select, { placeholder: "Image asset", showSearch: true, filterOption: filterOption, onChange: function (asset) { return setSelectedAsset(asset); }, value: selectedAsset, style: styles.modalFormSelect, size: "large", options: options }));
});
var VideoModal = react_1.default.memo(function (_a) {
    var assetOptions = _a.assetOptions, onOk = _a.onOk, onCancel = _a.onCancel, open = _a.open;
    var _b = (0, react_1.useState)(null), selectedAsset = _b[0], setSelectedAsset = _b[1];
    var onOk_ = (0, react_1.useCallback)(function () {
        if (!selectedAsset)
            return;
        onOk({ url: (0, utils_1.assetIdToBytesUrl)(selectedAsset) });
        setSelectedAsset(null);
    }, [selectedAsset, onOk]);
    var options = (0, react_1.useMemo)(function () { return assetOptions.map(function (asset) { return ({
        label: asset.file_name,
        value: asset.id,
        search: asset.file_name,
    }); }); }, [assetOptions]);
    // noinspection JSValidateTypes
    return react_1.default.createElement(antd_1.Modal, { title: "Insert Video", open: open, onOk: onOk_, onCancel: onCancel },
        react_1.default.createElement(antd_1.Select, { placeholder: "Video asset", showSearch: true, filterOption: filterOption, onChange: function (asset) { return setSelectedAsset(asset); }, value: selectedAsset, style: styles.modalFormSelect, size: "large", options: options }));
});
var HTMLEditor = function (_a) {
    var initialValue = _a.initialValue, onChange = _a.onChange, placeholder = _a.placeholder, innerRef = _a.innerRef, helpText = _a.helpText;
    var quillRef = (0, react_1.useRef)(null);
    var _b = (0, react_1.useState)([]), assetOptions = _b[0], setAssetOptions = _b[1];
    var _c = (0, react_1.useState)(null), currentRange = _c[0], setCurrentRange = _c[1];
    var _d = (0, react_1.useState)(""), currentSelection = _d[0], setCurrentSelection = _d[1];
    var _e = (0, react_1.useState)(null), showViewer = _e[0], setShowViewer = _e[1];
    var assets = (0, hooks_1.useAppSelector)(function (state) { return state.assets.items; });
    var stations = (0, hooks_2.useStations)().items;
    var modals = (0, hooks_1.useAppSelector)(function (state) { return state.modals.items; });
    var pages = (0, hooks_1.useAppSelector)(function (state) { return state.pages.items; });
    var assetHandler = function (type) { return function () {
        setCurrentRange(quillRef.current.getEditor().getSelection(true));
        setAssetOptions(assets.filter(function (a) { return a.asset_type === type; }));
        setShowViewer(type);
    }; };
    var linkHandler = function (type) { return function () {
        var sel = quillRef.current.getEditor().getSelection(true);
        if (!sel || !sel.length) {
            // TODO: Toast
            alert("No text selected.");
            return;
        }
        setCurrentRange(sel);
        setCurrentSelection(quillRef.current.getEditor().getText(sel.index, sel.length));
        setShowViewer(type);
    }; };
    var stationHandler = linkHandler("station");
    var modalHandler = linkHandler("modal");
    var pageHandler = linkHandler("page");
    var audioHandler = assetHandler("audio");
    var imageHandler = assetHandler("image");
    var videoHandler = assetHandler("video");
    var modules = {
        toolbar: {
            container: [
                [{ "header": [1, 2, 3, false] }],
                ["bold", "italic", "underline"],
                [{ "list": "ordered" }, { "list": "bullet" }],
                ["link"],
                ["clean"],
            ],
        },
    };
    if (initialValue === null)
        return react_1.default.createElement("div", null);
    var modalInsertClose = (0, react_1.useCallback)(function () { return setShowViewer(null); }, []);
    var modalInsertOk = (0, react_1.useCallback)(function (type) { return function (data) {
        if (!quillRef.current)
            return;
        if (!data)
            return;
        if (type === "link") {
            quillRef.current.getEditor().formatText(currentRange.index, currentRange.length, type, data, "user");
        }
        else {
            quillRef.current.getEditor().insertEmbed(currentRange.index, type, data, "user");
        }
        modalInsertClose();
    }; }, [modalInsertClose, quillRef, currentRange]);
    var dividerInsert = (0, react_1.useCallback)(function () {
        var cr = quillRef.current.getEditor().getSelection(true);
        quillRef.current.getEditor().insertEmbed(cr.index, "divider", {}, "user");
    }, [quillRef]);
    // noinspection JSValidateTypes
    return react_1.default.createElement("div", null,
        react_1.default.createElement(LinkModal, { objectName: "Station", objectPathItem: "stations", options: stations, linkText: currentSelection, open: showViewer === "station", onOk: modalInsertOk("link"), onCancel: modalInsertClose }),
        react_1.default.createElement(LinkModal, { objectName: "Modal", objectPathItem: "modals", options: modals, linkText: currentSelection, open: showViewer === "modal", onOk: modalInsertOk("link"), onCancel: modalInsertClose }),
        react_1.default.createElement(LinkModal, { objectName: "Page", objectPathItem: "pages", options: pages, linkText: currentSelection, open: showViewer === "page", onOk: modalInsertOk("link"), onCancel: modalInsertClose }),
        react_1.default.createElement(AudioModal, { assetOptions: assetOptions, open: showViewer === "audio", onOk: modalInsertOk("tgcsAudio"), onCancel: modalInsertClose }),
        react_1.default.createElement(ImageModal, { assetOptions: assetOptions, open: showViewer === "image", onOk: modalInsertOk("image"), onCancel: modalInsertClose }),
        react_1.default.createElement(VideoModal, { assetOptions: assetOptions, open: showViewer === "video", onOk: modalInsertOk("html5Video"), onCancel: modalInsertClose }),
        helpText && react_1.default.createElement("p", { style: styles_1.helpText }, helpText),
        react_1.default.createElement("div", { style: styles.editorContainer },
            react_1.default.createElement("div", { style: styles.extraToolbar },
                react_1.default.createElement(antd_1.Space, { direction: "horizontal" },
                    react_1.default.createElement(antd_1.Tooltip, { title: "Divider" },
                        react_1.default.createElement(antd_1.Button, { onClick: dividerInsert, icon: react_1.default.createElement("span", null, "\u2014") })),
                    react_1.default.createElement(antd_1.Divider, { type: "vertical", style: styles.extraToolbarDivider }),
                    react_1.default.createElement(antd_1.Button, { onClick: stationHandler, icon: react_1.default.createElement(icons_1.EnvironmentOutlined, null) }, "Station"),
                    react_1.default.createElement(antd_1.Button, { onClick: modalHandler, icon: react_1.default.createElement(icons_1.CloseSquareOutlined, null) }, "Modal"),
                    react_1.default.createElement(antd_1.Button, { onClick: pageHandler, icon: react_1.default.createElement(icons_1.FileOutlined, null) }, "Page"),
                    react_1.default.createElement(antd_1.Divider, { type: "vertical", style: styles.extraToolbarDivider }),
                    react_1.default.createElement(antd_1.Tooltip, { title: "Audio" },
                        react_1.default.createElement(antd_1.Button, { onClick: audioHandler, icon: react_1.default.createElement(icons_1.SoundOutlined, null) })),
                    react_1.default.createElement(antd_1.Tooltip, { title: "Image" },
                        react_1.default.createElement(antd_1.Button, { onClick: imageHandler, icon: react_1.default.createElement(icons_1.PictureOutlined, null) })),
                    react_1.default.createElement(antd_1.Tooltip, { title: "Video" },
                        react_1.default.createElement(antd_1.Button, { onClick: videoHandler, icon: react_1.default.createElement(icons_1.VideoCameraOutlined, null) })))),
            react_1.default.createElement(react_quill_1.default, { theme: "snow", ref: function (el) {
                    if (innerRef) {
                        if (typeof innerRef === "function") {
                            innerRef(el);
                        }
                        else {
                            innerRef.current = el;
                        }
                    }
                    quillRef.current = el;
                }, formats: FORMATS, modules: modules, defaultValue: initialValue, onChange: onChange, placeholder: placeholder })));
};
exports.default = HTMLEditor;
